import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import { Lot, Movement } from '../../entities/lots/lots.types';
import {
  CattleMovementsPayload,
  CloseoutPreviewPayload,
  DeliveryInLotCreation,
  DownloadCloseoutReportPayload,
  DownloadCostSummaryReportPayload,
  GetDeliveriesPayload,
  GroupInLotCreation,
  MovementInCreation,
} from './appLots.types';
import { ChargeType } from '../../entities/costTypes/costTypes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/appLots');
export const addGroupToLot = actionCreator<string>('ADD_GROUP_TO_LOT');
export const deleteGroupFromLot = actionCreator<string>('DELETE_GROUP_FROM_LOT');
export const editGroupInLot = actionCreator<Partial<GroupInLotCreation>>('EDIT_GROUP_IN_LOT');
export const reset = actionCreator('RESET');
export const getDeliveries = actionCreator.async<GetDeliveriesPayload, DeliveryInLotCreation[]>('GET_DELIVERIES');
export const resetDeliveries = actionCreator('RESET_DELIVERIES');
export const addMovement = actionCreator<MovementInCreation>('ADD_MOVEMENT');
export const deleteMovement = actionCreator<string>('DELETE_MOVEMENT');
export const editMovement = actionCreator<Partial<MovementInCreation>>('EDIT_MOVEMENT');
export const resetMovements = actionCreator('RESET_MOVEMENT');
export const getCloseoutReport = actionCreator.async<CloseoutPreviewPayload, any>('GET_CLOSEOUT_REPORT');
export const setIncludedCloseouts = actionCreator<string[]>('SET_INCLUDED_CLOSEOUTS');
export const setIncludedCloseoutsExisting = actionCreator<string[]>('SET_INCLUDED_CLOSEOUTS_EXISTING');
export const downloadCloseoutReport = actionCreator.async<DownloadCloseoutReportPayload, void>(
  'DOWNLOAD_CLOSEOUT_REPORT',
);
export const resetPreviewData = actionCreator('RESET_PREVIEW_DATA');
export const setTransfersHistoryLot = actionCreator<Lot | undefined>('SET_TRANSFERS_HISTORY_LOT');
export const setTransfersHistoryLotIsEdit = actionCreator<boolean>('SET_TRANSFER_HISTORY_LOT_IS_EDIT');
export const previewLot = actionCreator.async<Lot, Lot>('PREVIEW_LOT');
export const updateMovementInPreview = actionCreator<Partial<Movement>>('UPDATE_MOVEMENT_IN_PREVIEW');
export const addMovementInPreview = actionCreator<Partial<Movement>>('ADD_MOVEMENT_IN_PREVIEW');
export const resetTransfersHistory = actionCreator('RESET_TRANSFERS_HISTORY');
export const addTransfersHistoryMovement = actionCreator<MovementInCreation>('ADD_TRANSFERS_HISTORY_MOVEMENT');
export const updateTransfersHistoryMovement = actionCreator<Partial<MovementInCreation>>(
  'UPDATE_TRANSFERS_HISTORY_MOVEMENT',
);
export const deleteTransfersHistoryMovement = actionCreator<string>('DELETE_TRANSFERS_HISTORY_MOVEMENT');
export const disableReportFetching = actionCreator<boolean>('DISABLE_REPORT_FETCHING');
export const resetPdfData = actionCreator<void>('RESET_PDF_DATA');
export const setAutoExpandAdditionalCost = actionCreator<string>('SET_AUTO_EXPAND_ADDITIONAL_COST');
export const validateAdditionalCostEndDate = actionCreator<ChargeType>('VALIDATE_ADDITIONAL_COST_END_DATE');
export const getCostSummaryReport = actionCreator.async<{ id: string }, any>('GET_COST_SUMMARY_REPORT');
export const downloadCostSummaryReport =
  actionCreator<DownloadCostSummaryReportPayload>('DOWNLOAD_COST_SUMMARY_REPORT');
export const getLotCattleMovements = actionCreator.async<CattleMovementsPayload, {}>('GET_CATTLE_MOVEMENTS_REPORT');
